import React, { useState, useEffect } from 'react'
import PropTypes from 'prop-types'
import { Modal } from 'react-bootstrap'
import { client } from '@Utils'
import { DevKeyContainer } from './DevKeyContainer'
import { ltiOrgKeyManagement as endpoints } from '@URLS'

export const DevKeyModal = props => {
  const [organization, setOrganization] = useState(null)

  useEffect(() => {
    const fetchData = async () => {
      let resp = await client.get(
        endpoints.getOrgDetails({ orgId: props.orgId })
      )
      setOrganization(resp.data.organization)
    }
    try {
      fetchData()
    } catch (err) {
      console.log(err)
    }
  }, [])

  let modalContent = organization ? (
    <DevKeyContainer
      organization={organization}
      setOrganization={setOrganization}
      toggle={props.toggle}
    />
  ) : (
    <p>Loading...</p>
  )

  return (
    <Modal show={props.show} onHide={() => props.toggle(!props.show)}>
      <Modal.Header closeButton>
        <Modal.Title>Dev Key</Modal.Title>
      </Modal.Header>
      <Modal.Body>{modalContent}</Modal.Body>
    </Modal>
  )
}

DevKeyModal.propTypes = {
  orgId: PropTypes.string.isRequired,
  show: PropTypes.bool.isRequired,
  toggle: PropTypes.func.isRequired,
}
